const dateBar = (meta) => {
  if (!meta.month) {
    return { weekday: meta.weekday, center: meta.day, year: meta.year };
  }
  const weekday = meta.weekday.replace(/\.$/, '');
  return {
    weekday,
    center: `${meta.day} de ${meta.month} de`,
    year: meta.year,
  };
};

const EditorialPageFrame = ({ meta, layout, children }) => {
  const { weekday, center, year } = dateBar(meta);
  const bar = (
    <>
      <span>{weekday}</span>
      <span>{center}</span>
      <span>{year}</span>
    </>
  );

  return (
    <div className={layout ? `experience experience--${layout}` : 'experience'}>
      <header className="editorial-meta">{bar}</header>
      <main className="editorial-main">{children}</main>
      <footer className="editorial-meta editorial-meta--footer" aria-hidden="true">{bar}</footer>
    </div>
  );
};

export default EditorialPageFrame;
